// ZB Collapsible Content — accordion expand/collapse

(function () {
  function togglePanel(button) {
    var panelId = button.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;

    var isOpen = button.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.style.maxHeight = '0px';
      });
      button.setAttribute('aria-expanded', 'false');
      panel.addEventListener('transitionend', function handler() {
        panel.setAttribute('hidden', '');
        panel.removeEventListener('transitionend', handler);
      });
    } else {
      panel.removeAttribute('hidden');
      panel.style.maxHeight = '0px';
      requestAnimationFrame(function () {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
      button.setAttribute('aria-expanded', 'true');
      panel.addEventListener('transitionend', function handler() {
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', handler);
      });
    }
  }

  function initAccordion(root) {
    var buttons = root.querySelectorAll('[data-cc-toggle]');
    buttons.forEach(function (button) {
      // Initialize open-by-default panels with proper max-height
      if (button.getAttribute('aria-expanded') === 'true') {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.style.maxHeight = 'none';
      }

      button.addEventListener('click', function () {
        togglePanel(button);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.zb-cc').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-cc');
    if (root) initAccordion(root);
  });
})();